module.exports = __webpack_public_path__ + "img/orange_091.809bb7ff.png";